import { EEtazhiBlackFridayActionTypes } from 'shared/actions/etazhiBlackFriday';

import type { IAppState, TActions } from 'shared/common/state';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export const etazhiBlackFridayReducer = (state: IAppState, action: TActions): IAppState => {
  switch (action.type) {
    case EEtazhiBlackFridayActionTypes.SetPromoOffersData: {
      return {
        ...state,
        etazhiBlackFriday: {
          promoOffersData: action.payload,
        },
      };
    }

    default:
      return state;
  }
};
